<template>
  <div :class="setClassContainer" :style="setStyleContainer">
    <img :id="setIdImage" :src="setSourceImage" :class="setClassImage" :style="setStyleImage"/>
  </div>
</template>

<script>
  export default{
    name: 'navSlideComponent',

    props: ['setClassContainer', 'setClassImage', 'setIdImage', 'setSourceImage', 'setStyleContainer',
      'setStyleImage'],

    data() {
      return {};
    },

    mounted() {
      let imageDocument = document.getElementById(this.setIdImage);
      imageDocument.onload = function() {
        this.$emit('imageMounted', true);
      }.bind(this);
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/nav_slide_component.vue